import * as angular from 'angular';
import * as _ from 'lodash';

import { IHistorianStorageConfigurationService } from '../../services';
import { HistorianStorageConfiguration } from '../../models/entities/HistorianStorageConfiguration';
import { Store, Dispatcher } from '../Store';
import * as HSC from './hsc.constants';
import * as Actions from './hsc.actions';

export interface IHistorianStorageConfigurationActionsService {
    getAll(): Dispatcher<HistorianStorageConfiguration[]>;
    getAll(force: boolean): Dispatcher<HistorianStorageConfiguration[]>;
    updateMany(targets: HistorianStorageConfiguration[]): Dispatcher<HistorianStorageConfiguration[]>;
    deleteMany(guids: string[]): Dispatcher<HistorianStorageConfiguration[]>;
}

export class HistorianStorageConfigurationActionsService implements IHistorianStorageConfigurationActionsService {
    static serviceId = 'historianStorageConfigurationActionsService';
    static $inject = ['$q', 'historianStorageService'];
    
    constructor(
        private _$q: angular.IQService,
        private _hscService: IHistorianStorageConfigurationService) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean): Dispatcher<HistorianStorageConfiguration[]> {
        return (dispatch: any, getConfigurations: () => Store) => {
            const config = getConfigurations().historianStorageConfigurations;
            if (force || (!config.isLoading && !config.isLoaded)) {
                dispatch(Actions.loadHistorianStorageConfigurations());
                return this._hscService.getAll()
                    .then(data => {
                        dispatch(Actions.loadHistorianStorageConfigurationsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: HSC.HSCS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<HistorianStorageConfiguration>(config.dictionary));
            }
        };
    }

    updateMany(targets: HistorianStorageConfiguration[]): Dispatcher<HistorianStorageConfiguration[]> {
        return (dispatch: any, getStore: () => Store) => {
            const config = getStore().historianStorageConfigurations;
            if (targets && targets.length > 0) {
                dispatch(Actions.updateHistorianStorageConfigurations(targets));
                return this._hscService.save(targets)
                    .then(data => {
                        const result = data;
                        dispatch(Actions.updateHistorianStorageConfigurationsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: HSC.HSCS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<HistorianStorageConfiguration>(config.dictionary));
            }
        };
    }

    deleteMany(guids: string[]): Dispatcher<HistorianStorageConfiguration[]> {
        return (dispatch: any, getStore: () => Store) => {
            const config = getStore().historianStorageConfigurations;
            if (guids && guids.length > 0) {
                dispatch(Actions.deleteHistorianStorageConfigurations(guids));
                return this._hscService.delete(guids)
                    .then(data => {
                        const result = data;
                        dispatch(Actions.deleteHistorianStorageConfigurationsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: HSC.HSCS_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<HistorianStorageConfiguration>(config.dictionary));
            }
        };
    }
}